class SideCart {
    constructor(side_cart, cart) {
        this.side_cart = side_cart;
        this.cart = cart;

        this._removeFromCart = this._removeFromCart.bind(this);

        if (this.side_cart !== null) {
            this.side_cart_content = this.side_cart.querySelector(
                '[data-element="cart-content"]',
            );
        }
    }

    updateSideCart(cart_html) {
        if (this.side_cart_content !== null) {
            this.side_cart_content.innerHTML = cart_html;

            let cart_remove = this.side_cart_content.querySelectorAll(
                '[data-element="cart-remove"]',
            );
            if (cart_remove.length > 0) {
                cart_remove.forEach((cr) => {
                    cr.addEventListener("click", this._removeFromCart);
                });
            }
        }
    }

    _removeFromCart(event) {
        event.preventDefault();
        let product_id = event.target.getAttribute("data-product-id");
        let cart_key = event.target.getAttribute("data-cart-item-key");
        this.cart.removeFromCart(product_id, cart_key);
    }
}

export default SideCart;
